import { FragFinderHeading } from './FragFinderHeading'
import { FragNavButton } from './FragNavButton'
import { UserAvatar } from './UserAvatar'
import { useNavigate } from 'react-router-dom'
import Search from '../assets/search.svg?react'
import { useAuth } from '../pocketbase/useAuth'
import { useState, useEffect } from 'react'

interface INavBarProps {
  hideTitle?: boolean
  dashboardMenu?: React.ReactNode
  onSearchClick?: () => void
}

export const NavBar = (props: INavBarProps) => {
  const navigate = useNavigate()
  const { isLoggedIn } = useAuth()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768) // 768px is the md breakpoint
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const onSubmitClick = () => {
    navigate('/submit')
  }

  const onLoginClick = () => {
    navigate('/login')
  }

  const onAvatarClick = () => {
    navigate('/dashboard')
  }

  const handleSearchClick = () => {
    if (props.onSearchClick) {
      props.onSearchClick()
    } else {
      navigate('/', { state: { scrollToSearch: true } })
    }
  }

  return (
    <nav
      className="fixed top-0 left-0 w-full bg-white border-b border-gray-200 z-1"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className={'relative flex md:px-8 px-6 md:h-[90px] h-[75px] items-center justify-between'}>
        {/* Left side */}
        <div className={'flex items-center'}>
          <button
            onClick={handleSearchClick}
            className={'cursor-pointer hover:opacity-70 transition-opacity'}
          >
            <Search width={24} height={24} />
          </button>
        </div>

        {/* Center */}
        <FragFinderHeading
          className={`cursor-pointer absolute left-1/2 transform -translate-x-1/2 md:text-4xl text-2xl leading-normal transition-opacity duration-300 ${props.hideTitle ? 'opacity-0' : 'opacity-100'
            }`}
          text={'Explore Scents'}
          onClick={handleSearchClick}
        />

        {/* Right side */}
        {isLoggedIn() ? (
          <div className={'flex items-center gap-4'}>
            {!isMobile && <FragNavButton text={'Submit'} onClick={onSubmitClick} />}
            <div>{props.dashboardMenu ?? <UserAvatar onClick={onAvatarClick} />}</div>
          </div>
        ) : (
          <FragNavButton text={'Login'} onClick={onLoginClick} />
        )}
      </div>
    </nav>
  )
}
